import { useInfiniteQuery, useQuery } from 'react-query';
import pecaAiServices from './pecaAi.services';
import notificationError from '@/utils/functions/notificationError';
import {
  EnterprisePecaAiSearchProductRequest,
  EnterprisePecaAiToken,
} from './pecaAi.types';

const PECA_AI_TOKEN_STORAGE = 'peca_ai.access_token';

export function getPecaAiAccessToken(): EnterprisePecaAiToken | null {
  const data = localStorage.getItem(PECA_AI_TOKEN_STORAGE);
  if (data) return JSON.parse(data);
  return null;
}

export function setPecaAiAccessToken(data: EnterprisePecaAiToken) {
  localStorage.setItem(PECA_AI_TOKEN_STORAGE, JSON.stringify(data));
}

export function useEnterprisePecaAiToken(enabled = true) {
  return useQuery(
    ['enterprise/peca-ai/token'],
    () => pecaAiServices.getToken(),
    {
      enabled: enabled,
      onSuccess(data) {
        localStorage.setItem(PECA_AI_TOKEN_STORAGE, JSON.stringify(data));
      },
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useEnterprisePecaAiBuyer(companyId?: number, enabled = true) {
  return useQuery(
    ['enterprise/peca-ai/buyer', { companyId }],
    () => pecaAiServices.getBuyer(companyId),
    {
      enabled: !!companyId && enabled,
    },
  );
}

export function useEnterprisePecaAiSearchProduct(
  params?: EnterprisePecaAiSearchProductRequest,
  enabled = true,
) {
  return useInfiniteQuery(
    ['enterprise/peca-ai/search-product', { ...params }],
    ({ pageParam }) =>
      pecaAiServices.searchProduct({ ...params, nextToken: pageParam }),
    {
      enabled: enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}
